import type { AdminUser } from './firebase';

// Heurística de registro sospechoso (probable granja de cuentas Gmail / bot).
//
// NO es una señal oficial de Google — no existe tal cosa. Es una marca blanda
// para que el admin revise: email tipo `nombreapellido.NNNNN@gmail.com` (5±
// dígitos tras un punto) Y actividad 0 (nunca generó un informe). Ambas
// condiciones juntas reducen falsos positivos frente al patrón de email solo
// (un usuario real con ese email pero con informes NO se marca).
//
// Contexto del hallazgo 2026-07-04: 72/94 usuarios casaban el patrón, TODOS con
// actividad 0, varios con el mismo nombre y distinto sufijo numérico.

export const SUSPICIOUS_EMAIL = /^[a-z]+(?:\.[a-z]+)*\.\d{4,7}@(?:gmail|googlemail)\.com$/i;

export function isSuspiciousUser(u: AdminUser): boolean {
  const activity = u.fullReportsCount ?? u.reportsCount ?? 0;
  return !!u.email && SUSPICIOUS_EMAIL.test(u.email) && activity === 0;
}
